import React from "react";
import {Col, Divider, Row} from 'antd';

const steps = (t: (x: string) => any) => {
    return {
        stepsAdmin: [
            {
                selector: '[data-tut="reactour__init"]',
                content: () => {
                    return (
                        <div>
                            <Row gutter={0} >
                                <Col span={24}><b> {t("Welcome to the virtual tour of Time Tracking")}</b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24}>{t("On this platform you can keep track of the hours worked as well as summary of them. To do this we propose you to follow the steps below...")}</Col>
                            </Row>
                        </div>
                    )
                }
            },
            {
                selector: '[data-tut="reactour__myTimesheets"]',
                content: () => {
                    return (
                        <div>
                            <Row gutter={0} >
                                <Col span={24}><b> {t("Browse the main page")} </b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24} style={{}}> {t("Here you can see the timesheets published by you, as well as publish new")}</Col>
                            </Row>
                        </div>
                    )
                }
            },
            {
                selector: '[data-tut="reactour__teamTimesheets"]',
                content: () => {
                    return (
                        <div>
                            <Row gutter={0} >
                                <Col span={24}><b> {t("Browse the main page")}</b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24} style={{}}> {t("Here you can see the timesheets that belong to your team as well as validate or reject the timesheets published by your team members")}</Col>
                            </Row>
                        </div>
                    )
                }
            },
            {
                selector: '[data-tut="reactour__myReports"]',
                content: () => {
                    return (
                        <div>
                            <Row gutter={0} >
                                <Col span={24}><b> {t("Browse the main page")} </b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24} style={{}}> {t("Here you can see your Reports")}</Col>
                            </Row>
                        </div>
                    )
                }
            },
            {
                selector: '[data-tut="reactour__changeCompany"]',
                content: () => {
                    return (
                        <div>
                            <Row gutter={0} >
                                <Col span={24}><b> {t("Browse the main page")}</b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24} style={{}}> {t("Here you can select the company where you want to view or publish the timesheets")}</Col>
                            </Row>
                        </div>
                    )
                }
            },
            {
                selector: '[data-tut="reactour__filterTimesheet"]',
                content: () => {
                    return (
                        <div>
                            <Row gutter={0} >
                                <Col span={24}><b> {t("Browse the main page")}</b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24} style={{}}> {t("Here you can filter and sort your timesheets according to project name, week or month")} </Col>
                            </Row>
                        </div>
                    )
                }
            },
            {
                selector: '[data-tut="reactour__exploreTimesheet"]',
                content: () => {
                    return (
                        <div>
                            <Row gutter={0} >
                                <Col span={24}><b> {t("Browse the main page")}</b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24} style={{}}> {t("Here you can explore your timesheets of the selected week, you can also filter them by the project name")} </Col>
                            </Row>
                        </div>
                    )
                }
            },
            {
                selector: '[data-tut="reactour__fillTimesheet"]',
                content: () => {
                    return (
                        <div>
                            <Row gutter={0} >
                                <Col span={24}><b> {t("Fill in the timesheet")} </b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24} style={{}}> {t("Here you can fill in and edit a timesheet")}</Col>
                            </Row>
                        </div>
                    )
                }
            },
            {
                selector: '[data-tut="reactour__saveTimesheet"]',
                content: () => {
                    return (
                        <div>
                            <Row gutter={0} >
                                <Col span={24}><b> {t("Save timesheet")}</b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24} style={{}}> {t("Here you can save and publish the changes made to your timesheet once you have modified them. Also you can download the selected timesheet")} </Col>
                            </Row>
                        </div>
                    )
                }
            },
            {
                selector: '[data-tut="reactour__createtask"]',
                content: () => {
                    return (
                        <div>
                            <Row gutter={0} >
                                <Col span={24}><b> {t("Creating the task")} </b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24} style={{}}> {t("Here you can create a task belonging to a project that you select")} </Col>
                            </Row>
                        </div>
                    )
                }
            },
            {
                selector: '[data-tut="reactour__config"]',
                content: () => {
                    return (
                        <div>
                            <Row gutter={0} >
                                <Col span={24}><b> {t("Settings")}</b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24} style={{}}> {t("Here you can add or modify companies in the system. You can view and edit the parameters of the companies, add new employees, create and assign projects")} </Col>
                            </Row>
                        </div>
                    )
                }
            }
        ],

        stepsMyTeam: [
            {
                selector: '[data-tut="reactour__init"]',
                content: () => {
                    return (
                        <div>
                            <Row gutter={0} >
                                <Col span={24}><b> {t("Starting My Team's Timesheets view tour")}</b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24}>{t("Here you can explore and edit the timesheets that belong to your team as well as validate or reject the timesheets published by your team members. All steps are equal to steps in My timesheets")}</Col>
                            </Row>
                        </div>
                    )
                }
            },
            {
                selector: '[data-tut="reactour__saveTimesheet"]',
                content: () => {
                    return (
                        <div>
                            <Row gutter={0} >
                                <Col span={24}><b> {t("Validate and reject timesheet")}</b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24} style={{}}> {t("Here you can validate or reject published timesheets by members of your team. Also you can download the selected timesheet")} </Col>
                            </Row>
                        </div>
                    )
                }
            }
        ],

        stepsAdminNoTimesheets: [
            {
                selector: '[data-tut="reactour__init"]',
                content: () => {
                    return (
                        <div>
                            <Row gutter={0} >
                                <Col span={24}><b> {t("Welcome to the virtual tour of Time Tracking")}</b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24}>{t("On this platform you can keep track of the hours worked as well as summary of them. To do this we propose you to follow the steps below...")}</Col>
                            </Row>
                        </div>
                    )
                }
            },
            {
                selector: '[data-tut="reactour__myTimesheets"]',
                content: () => {
                    return (
                        <div>
                            <Row gutter={0} >
                                <Col span={24}><b> {t("Browse the main page")} </b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24} style={{}}> {t("Here you can see the timesheets published by you, as well as publish new")}</Col>
                            </Row>
                        </div>
                    )
                }
            },
            {
                selector: '[data-tut="reactour__teamTimesheets"]',
                content: () => {
                    return (
                        <div>
                            <Row gutter={0} >
                                <Col span={24}><b> {t("Browse the main page")}</b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24} style={{}}> {t("Here you can see the timesheets that belong to your team as well as validate or reject the timesheets published by your team members")}</Col>
                            </Row>
                        </div>
                    )
                }
            },
            {
                selector: '[data-tut="reactour__changeCompany"]',
                content: () => {
                    return (
                        <div>
                            <Row gutter={0} >
                                <Col span={24}><b> {t("Browse the main page")}</b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24} style={{}}> {t("Here you can select the company where you want to view or publish the timesheets")}</Col>
                            </Row>
                        </div>
                    )
                }
            },
            {
                selector: '[data-tut="reactour__companyTimesheets"]',
                content: () => {
                    return (
                        <div>
                            <Row gutter={0} >
                                <Col span={24}><b> {t("Browse the main page")}</b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24} style={{}}> {t("Here you can view and edit the parameters of your company, add new employees, create and assign projects")}</Col>
                            </Row>
                        </div>
                    )
                }
            }, {
                selector: '[data-tut="reactour__filterTimesheet"]',
                content: () => {
                    return (
                        <div>
                            <Row gutter={0} >
                                <Col span={24}><b> {t("Browse the main page")}</b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24} style={{}}> {t("Here you can filter and sort your timesheets according to project name, week or month")} </Col>
                            </Row>
                        </div>
                    )
                }
            }, {
                selector: '[data-tut="reactour__exploreTimesheet"]',
                content: () => {
                    return (
                        <div>
                            <Row gutter={0} >
                                <Col span={24}><b> {t("Browse the main page")}</b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24} style={{}}> {t("Here you can explore your timesheets of the selected week, you can also filter them by the project name")} </Col>
                            </Row>
                        </div>
                    )
                }
            },
            {
                selector: '[data-tut="reactour__config"]',
                content: () => {
                    return (
                        <div>
                            <Row gutter={0} >
                                <Col span={24}><b> {t("Settings")}</b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24} style={{}}> {t("Here you can add or modify companies in the system")} </Col>
                            </Row>
                        </div>
                    )
                }
            }
        ],

        stepsUser: [
            {
                selector: '[data-tut="reactour__init"]',
                content: () => {
                    return (
                        <div>
                            <Row gutter={0} >
                                <Col span={24}><b>{t("Welcome to the virtual tour of Time Tracking")}</b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24}>{t("On this platform you can keep track of the hours worked as well as summary of them. To do this we propose you to follow the steps below...")}</Col>
                            </Row>
                        </div>
                    )
                }
            },
            {
                selector: '[data-tut="reactour__changeCompany"]',
                content: () => {
                    return (
                        <div>
                            <Row gutter={0} >
                                <Col span={24}><b> {t("Browse the main page")}</b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24} style={{}}> {t("Here you can select the company where you want to view or publish the timesheets")}</Col>
                            </Row>
                        </div>
                    )
                }
            },
            {
                selector: '[data-tut="reactour__filterTimesheet"]',
                content: () => {
                    return (
                        <div>
                            <Row gutter={0} >
                                <Col span={24}><b> {t("Browse the main page")}</b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24} style={{}}> {t("Here you can filter and sort your timesheets according to project name, week or month")} </Col>
                            </Row>
                        </div>
                    )
                }
            }, {
                selector: '[data-tut="reactour__exploreTimesheet"]',
                content: () => {
                    return (
                        <div>
                            <Row gutter={0} >
                                <Col span={24}><b> {t("Browse the main page")}</b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24} style={{}}> {t("Here you can explore your timesheets of the selected week, you can also filter them by the project name")} </Col>
                            </Row>
                        </div>
                    )
                }
            },
            {
                selector: '[data-tut="reactour__fillTimesheet"]',
                content: () => {
                    return (
                        <div>
                            <Row gutter={0} >
                                <Col span={24}><b> {t("Fill in the timesheet")}</b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24} style={{}}> {t("Here you can fill in and edit a timesheet")}</Col>
                            </Row>
                        </div>
                    )
                }
            },
            {
                selector: '[data-tut="reactour__saveTimesheet"]',
                content: () => {
                    return (
                        <div>
                            <Row gutter={0} >
                                <Col span={24}><b> {t("Save timesheet")}</b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24} style={{}}> {t("Here you can save and publish the changes made to your timesheet once you have modified them. Also you can download the selected timesheet")} </Col>
                            </Row>
                        </div>
                    )
                }
            },
            {
                selector: '[data-tut="reactour__createtask"]',
                content: () => {
                    return (
                        <div>
                            <Row gutter={0} >
                                <Col span={24}><b> {t("Creating the task")}</b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24} style={{}}> {t("Here you can create a task belonging to a project that you select")}</Col>
                            </Row>
                        </div>
                    )
                }
            }
        ],

        stepsNewUser: [
            {
                selector: '[data-tut="reactour__init"]',
                content: () => {
                    return (
                        <div>
                            <Row gutter={0} >
                                <Col span={24}><b>{t("Welcome to the virtual tour of Time Tracking")}</b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24}>{t("On this platform you can keep track of the hours worked as well as summary of them. To do this we propose you to follow the steps below...")}</Col>
                            </Row>
                        </div>
                    )
                }
            },
            {
                selector: '[data-tut="reactour__changeCompany"]',
                content: () => {
                    return (
                        <div>
                            <Row gutter={0} >
                                <Col span={24}><b> {t("Browse the main page")}</b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24} style={{}}> {t("Here you can select the company where you want to view or publish the timesheets")}</Col>
                            </Row>
                        </div>
                    )
                }
            },
            {
                selector: '[data-tut="reactour__filterTimesheet"]',
                content: () => {
                    return (
                        <div>
                            <Row gutter={0} >
                                <Col span={24}><b> {t("Browse the main page")}</b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24} style={{}}> {t("Here you can filter and sort your timesheets according to project name, week or month")} </Col>
                            </Row>
                        </div>
                    )
                }
            }, {
                selector: '[data-tut="reactour__exploreTimesheet"]',
                content: () => {
                    return (
                        <div>
                            <Row gutter={0} >
                                <Col span={24}><b> {t("Browse the main page")}</b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24} style={{}}> {t("Here you can explore your timesheets of the selected week, you can also filter them by the project name")} </Col>
                            </Row>
                        </div>
                    )
                }
            },
        ],

        stepsCompany: [
            {
                selector: '[data-tut="reactour__companyInit"]',
                content: () => {
                    return (
                        <div>
                            <Row gutter={0} >
                                <Col span={24}><b> {t("Starting the companies view tour")} </b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24} style={{}}> {t("To do this we propose you to follow the steps below...")} </Col>
                            </Row>
                        </div>
                    )
                }
            },
            {
                selector: '[data-tut="reactour__navegateCompany1"]',
                content: () => {
                    return (
                        <div >
                            <Row gutter={0} >
                                <Col span={24}><b> {t("Company form")} </b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24}>
                                    {t("Enter or edit the company name or reference")}
                                </Col>
                            </Row>
                        </div>
                    )
                },
            }, {
                selector: '[data-tut="reactour__navegateCompany2"]',
                content: () => {
                    return (
                        <div >
                            <Row gutter={0} >
                                <Col span={24}><b> {t("Company form")}</b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24}>
                                    {t("Select the company's default working regime. Employees who do not have a defined working regime will use the one corresponding to the company. Once the company form has been modified save or discard your changes.")}
                                </Col>
                            </Row>
                        </div>
                    )
                },
            },
        ],

        stepsEmployees: [
            {
                selector: '[data-tut="reactour__employeeInit"]',
                content: () => {
                    return (
                        <div>
                            <Row gutter={0} >
                                <Col span={24}><b> {t("Starting the journey through the Employees view")}</b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24} style={{}}> {t("To do this we propose you to follow the steps below...")} </Col>
                            </Row>
                        </div>
                    )
                }
            },
            {
                selector: '[data-tut="reactour__navegateEmployee"]',
                content: () => {
                    return (
                        <div >
                            <Row gutter={0} >
                                <Col span={24}><b> {t("Company employee view")}</b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24}>
                                    {t("Browse and filter employees for the selected company")}
                                </Col>
                            </Row>
                        </div>
                    )
                },
                position: 'center',
            }, {
                selector: '[data-tut="reactour__navegateEmployee1"]',
                content: () => {
                    return (
                        <div >
                            <Row gutter={0} >
                                <Col span={24}><b> {t("Company employee view")}</b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24}>
                                    {t("Add a new employee to the company, or bulk import new employees")}
                                </Col>
                            </Row>
                        </div>
                    )
                },

            },
            {
                selector: '[data-tut="reactour__navegateEmployee2"]',
                content: () => {
                    return (
                        <div >
                            <Row gutter={0} >
                                <Col span={24}><b> {t("Company employee view")}</b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24}>
                                    {t("Selecting an employee from the list allows you to enter the employee's editing view")}
                                </Col>
                            </Row>
                        </div>
                    )
                },
            },
        ],

        stepsEmployeesReadOnly: [
            {
                selector: '[data-tut="reactour__employeeInit"]',
                content: () => {
                    return (
                        <div>
                            <Row gutter={0} >
                                <Col span={24}><b> {t("Starting the journey through the Employees view")}</b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24} style={{}}> {t("To do this we propose you to follow the steps below...")} </Col>
                            </Row>
                        </div>
                    )
                }
            },
            {
                selector: '[data-tut="reactour__navegateEmployee"]',
                content: () => {
                    return (
                        <div >
                            <Row gutter={0} >
                                <Col span={24}><b> {t("Company employee view")}</b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24}>
                                    {t("Browse and filter employees for the selected company")}
                                </Col>
                            </Row>
                        </div>
                    )
                },
                position: 'center',
            },
            {
                selector: '[data-tut="reactour__navegateEmployee2"]',
                content: () => {
                    return (
                        <div >
                            <Row gutter={0} >
                                <Col span={24}><b> {t("Company employee view")}</b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24}>
                                    {t("Selecting an employee from the list allows you to enter the employee's editing view")}
                                </Col>
                            </Row>
                        </div>
                    )
                },
            },
        ],

        stepsProjects: [
            {
                selector: '[data-tut="reactour__projectsInit"]',
                content: () => {
                    return (
                        <div>
                            <Row gutter={0} >
                                <Col span={24}><b> {t("Starting the tour of the Projects view")}</b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24} style={{}}> {t("To do this we propose you to follow the steps below...")}</Col>
                            </Row>
                        </div>
                    )
                }
            },
            {
                selector: '[data-tut="reactour__navegateProject"]',
                content: () => {
                    return (
                        <div >
                            <Row gutter={0} >
                                <Col span={24}><b> {t("View of the company's projects")} </b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24}>
                                    {t("Browse and filter projects for the selected company")}
                                </Col>
                            </Row>
                        </div>
                    )
                },
                position: 'center',
            }, {
                selector: '[data-tut="reactour__navegateProject1"]',
                content: () => {
                    return (
                        <div >
                            <Row gutter={0} >
                                <Col span={24}><b> {t("View of the company's projects")}</b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24}>
                                    {t("Add a new project to the company")}
                                </Col>
                            </Row>
                        </div>
                    )
                }
            },
            {
                selector: '[data-tut="reactour__navegateProject2"]',
                content: () => {
                    return (
                        <div >
                            <Row gutter={0} >
                                <Col span={24}><b> {t("View of the company's projects")}</b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24}>
                                    {t("Selecting a project from the list allows you to enter the project's editing view.  Where it would be possible to edit the parameters of the project, add the project members, create and assign tasks.")}
                                </Col>
                            </Row>
                        </div>
                    )
                },
            },
        ],
        stepsProjectsReadOnly: [
            {
                selector: '[data-tut="reactour__projectsInit"]',
                content: () => {
                    return (
                        <div>
                            <Row gutter={0} >
                                <Col span={24}><b> {t("Starting the tour of the Projects view")}</b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24} style={{}}> {t("To do this we propose you to follow the steps below...")}</Col>
                            </Row>
                        </div>
                    )
                }
            },
            {
                selector: '[data-tut="reactour__navegateProject"]',
                content: () => {
                    return (
                        <div >
                            <Row gutter={0} >
                                <Col span={24}><b> {t("View of the company's projects")} </b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24}>
                                    {t("Browse and filter projects for the selected company")}
                                </Col>
                            </Row>
                        </div>
                    )
                },
                position: 'center',
            },
            {
                selector: '[data-tut="reactour__navegateProject2"]',
                content: () => {
                    return (
                        <div >
                            <Row gutter={0} >
                                <Col span={24}><b> {t("View of the company's projects")}</b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24}>
                                    {t("Selecting a project from the list allows you to enter the project's editing view.  Where it would be possible to edit the parameters of the project, add the project members, create and assign tasks.")}
                                </Col>
                            </Row>
                        </div>
                    )
                },
            },
        ],

        stepsTimesheets: [
            {
                selector: '[data-tut="reactour__timesheetInit"]',
                content: () => {
                    return (
                        <div>
                            <Row gutter={0} >
                                <Col span={24}><b> {t("Starting the journey through the Timesheets view")}</b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24} style={{}}> {t("To do this we propose you to follow the steps below...")}</Col>
                            </Row>
                        </div>
                    )
                }
            },
            {
                selector: '[data-tut="reactour__navegateTimesheet"]',
                content: () => {
                    return (
                        <div >
                            <Row gutter={0} >
                                <Col span={24}><b> {t("Company timesheets view")} </b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24}>
                                    {t("Browse and filter the timesheets of the selected company")}
                                </Col>
                            </Row>
                        </div>
                    )
                },
                position: 'center',
            }, {
                selector: '[data-tut="reactour__importTimesheet"]',
                content: () => {
                    return (
                        <div >
                            <Row gutter={0} >
                                <Col span={24}><b> {t("Company timesheets view")}</b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24}>
                                    {t("Perform a bulk import of new timesheets")}
                                </Col>
                            </Row>
                        </div>
                    )
                }
            },
            {
                selector: '[data-tut="reactour__selectTimesheet"]',
                content: () => {
                    return (
                        <div >
                            <Row gutter={0} >
                                <Col span={24}><b> {t("Company timesheets view")}</b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24}>
                                    {t("Selecting a timesheet from the list allows you to enter the timesheet details view")}
                                </Col>
                            </Row>
                        </div>
                    )
                },
            },
        ],

        stepsTimesheetsReadOnly: [
            {
                selector: '[data-tut="reactour__timesheetInit"]',
                content: () => {
                    return (
                        <div>
                            <Row gutter={0} >
                                <Col span={24}><b> {t("Starting the journey through the Timesheets view")}</b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24} style={{}}> {t("To do this we propose you to follow the steps below...")}</Col>
                            </Row>
                        </div>
                    )
                }
            },
            {
                selector: '[data-tut="reactour__navegateTimesheet"]',
                content: () => {
                    return (
                        <div >
                            <Row gutter={0} >
                                <Col span={24}><b> {t("Company timesheets view")} </b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24}>
                                    {t("Browse and filter the timesheets of the selected company")}
                                </Col>
                            </Row>
                        </div>
                    )
                },
                position: 'center',
            },
            {
                selector: '[data-tut="reactour__selectTimesheet"]',
                content: () => {
                    return (
                        <div >
                            <Row gutter={0} >
                                <Col span={24}><b> {t("Company timesheets view")}</b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24}>
                                    {t("Selecting a timesheet from the list allows you to enter the timesheet details view")}
                                </Col>
                            </Row>
                        </div>
                    )
                },
            },
        ],

        stepsReports: [
            {
                selector: '[data-tut="reactour__reportInit"]',
                content: () => {
                    return (
                        <div>
                            <Row gutter={0} >
                                <Col span={24}><b> {t("Starting the journey through the Reports view")}</b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24} style={{}}> {t("To do this we propose you to follow the steps below...")}</Col>
                            </Row>
                        </div>
                    )
                }
            },
            {
                selector: '[data-tut="reactour__navegateReport"]',
                content: () => {
                    return (
                        <div >
                            <Row gutter={0} >
                                <Col span={24}><b> {t("View a report")} </b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24}>
                                    {t("Select an option to report by employee or project")}
                                </Col>
                            </Row>
                        </div>
                    )
                },
                position: 'left',
            },
            {
                selector: '[data-tut="reactour__navegateMyReports"]',
                content: () => {
                    return (
                        <div >
                            <Row gutter={0} >
                                <Col span={24}><b> {t("View a report")} </b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24}>
                                    {t("Select an option to report by employee, project or eligibility")}
                                </Col>
                            </Row>
                        </div>
                    )
                },
                position: 'left',
            },
            {
                selector: '[data-tut="reactour__navegateReport1"]',
                content: () => {
                    return (
                        <div >
                            <Row gutter={0} >
                                <Col span={24}><b> {t("View a report")}</b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24}>
                                    {t("Select which employee or project you want to report from")}
                                </Col>
                            </Row>
                        </div>
                    )
                }
            },
            {
                selector: '[data-tut="reactour__navegateReport2"]',
                content: () => {
                    return (
                        <div >
                            <Row gutter={0} >
                                <Col span={24}><b> {t("View a report")}</b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24}>
                                    {t("Select the initial date where you want to report")}
                                </Col>
                            </Row>
                        </div>
                    )
                }
            },
            {
                selector: '[data-tut="reactour__navegateReport3"]',
                content: () => {
                    return (
                        <div >
                            <Row gutter={0} >
                                <Col span={24}><b> {t("View a report")}</b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24}>
                                    {t("Select the final date where you want to report")}
                                </Col>
                            </Row>
                        </div>
                    )
                },
            },
            {
                selector: '[data-tut="reactour__navegateReport4"]',
                content: () => {
                    return (
                        <div >
                            <Row gutter={0} >
                                <Col span={24}><b> {t("View a report")}</b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24}>
                                    {t("Click to view the report")}
                                </Col>
                            </Row>
                        </div>
                    )
                },
            },
            {
                selector: '[data-tut="reactour__navegateReport5"]',
                content: () => {
                    return (
                        <div >
                            <Row gutter={0} >
                                <Col span={24}><b> {t("View a report")}</b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24}>
                                    {t("This is the step by step of this section, you are welcome!")}
                                </Col>
                            </Row>
                        </div>
                    )
                },
            },
        ],

        stepsReportsProjects: [
            {
                selector: '[data-tut="reactour__reportInit"]',
                content: () => {
                    return (
                        <div>
                            <Row gutter={0} >
                                <Col span={24}><b> {t("Starting the journey through the Reports view")}</b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24} style={{}}> {t("To do this we propose you to follow the steps below...")}</Col>
                            </Row>
                        </div>
                    )
                }
            },
            {
                selector: '[data-tut="reactour__navegateReport"]',
                content: () => {
                    return (
                        <div >
                            <Row gutter={0} >
                                <Col span={24}><b> {t("View a report")} </b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24}>
                                    {t("Select an option to report by employee or project")}
                                </Col>
                            </Row>
                        </div>
                    )
                },
                position: 'left',
            },
            {
                selector: '[data-tut="reactour__navegateMyReports"]',
                content: () => {
                    return (
                        <div >
                            <Row gutter={0} >
                                <Col span={24}><b> {t("View a report")} </b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24}>
                                    {t("Select an option to report by employee, project or eligibility")}
                                </Col>
                            </Row>
                        </div>
                    )
                },
                position: 'left',
            },
            {
                selector: '[data-tut="reactour__navegateReport1p"]',
                content: () => {
                    return (
                        <div >
                            <Row gutter={0} >
                                <Col span={24}><b> {t("View a report")}</b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24}>
                                    {t("Select which employee or project you want to report from")}
                                </Col>
                            </Row>
                        </div>
                    )
                }
            },
            {
                selector: '[data-tut="reactour__navegateReport2p"]',
                content: () => {
                    return (
                        <div >
                            <Row gutter={0} >
                                <Col span={24}><b> {t("View a report")}</b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24}>
                                    {t("Select the initial date where you want to report")}
                                </Col>
                            </Row>
                        </div>
                    )
                }
            },
            {
                selector: '[data-tut="reactour__navegateReport3p"]',
                content: () => {
                    return (
                        <div >
                            <Row gutter={0} >
                                <Col span={24}><b> {t("View a report")}</b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24}>
                                    {t("Select the final date where you want to report")}
                                </Col>
                            </Row>
                        </div>
                    )
                },
            },
            {
                selector: '[data-tut="reactour__navegateReport4p"]',
                content: () => {
                    return (
                        <div >
                            <Row gutter={0} >
                                <Col span={24}><b> {t("View a report")}</b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24}>
                                    {t("Click to view the report")}
                                </Col>
                            </Row>
                        </div>
                    )
                },
            },
            {
                selector: '[data-tut="reactour__navegateReport5p"]',
                content: () => {
                    return (
                        <div >
                            <Row gutter={0} >
                                <Col span={24}><b> {t("View a report")}</b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24}>
                                    {t("This is the step by step of this section, you are welcome!")}
                                </Col>
                            </Row>
                        </div>
                    )
                },
            },
        ],

        stepsReportseligibilitye: [
            {
                selector: '[data-tut="reactour__reportInit"]',
                content: () => {
                    return (
                        <div>
                            <Row gutter={0} >
                                <Col span={24}><b> {t("Starting the journey through the Reports view")}</b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24} style={{}}> {t("To do this we propose you to follow the steps below...")}</Col>
                            </Row>
                        </div>
                    )
                }
            },
            {
                selector: '[data-tut="reactour__navegateReport"]',
                content: () => {
                    return (
                        <div >
                            <Row gutter={0} >
                                <Col span={24}><b> {t("View a report")} </b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24}>
                                    {t("Select an option to report by employee or project")}
                                </Col>
                            </Row>
                        </div>
                    )
                },
                position: 'left',
            },
            {
                selector: '[data-tut="reactour__navegateMyReports"]',
                content: () => {
                    return (
                        <div >
                            <Row gutter={0} >
                                <Col span={24}><b> {t("View a report")} </b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24}>
                                    {t("Select an option to report by employee, project or eligibility")}
                                </Col>
                            </Row>
                        </div>
                    )
                },
                position: 'left',
            },
            {
                selector: '[data-tut="reactour__navegateReport1e"]',
                content: () => {
                    return (
                        <div >
                            <Row gutter={0} >
                                <Col span={24}><b> {t("View a report")}</b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24}>
                                    {t("Select which employee or project you want to report from")}
                                </Col>
                            </Row>
                        </div>
                    )
                }
            },
            {
                selector: '[data-tut="reactour__navegateReport2e"]',
                content: () => {
                    return (
                        <div >
                            <Row gutter={0} >
                                <Col span={24}><b> {t("View a report")}</b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24}>
                                    {t("Select the date range where you want to report")}
                                </Col>
                            </Row>
                        </div>
                    )
                }
            },
            {
                selector: '[data-tut="reactour__navegateReport3e"]',
                content: () => {
                    return (
                        <div >
                            <Row gutter={0} >
                                <Col span={24}><b> {t("View a report")}</b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24}>
                                    {t("Select  projects or tasks")}
                                </Col>
                            </Row>
                        </div>
                    )
                },
            },
            {
                selector: '[data-tut="reactour__navegateReport4e"]',
                content: () => {
                    return (
                        <div >
                            <Row gutter={0} >
                                <Col span={24}><b> {t("View a report")}</b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24}>
                                    {t("Select schemes and units")}
                                </Col>
                            </Row>
                        </div>
                    )
                },
            },
            {
                selector: '[data-tut="reactour__navegateReport5e"]',
                content: () => {
                    return (
                        <div >
                            <Row gutter={0} >
                                <Col span={24}><b> {t("View a report")}</b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24}>
                                    {t("Click to view the report")}
                                </Col>
                            </Row>
                        </div>
                    )
                },
            },
        ],

        stepsTemplates: [
            {
                selector: '[data-tut="reactour__templateInit"]',
                content: () => {
                    return (
                        <div>
                            <Row gutter={0} >
                                <Col span={24}><b> {t("Starting the journey through the Templates view")}</b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24} style={{}}> {t("To do this we propose you to follow the steps below...")}</Col>
                            </Row>
                        </div>
                    )
                }
            },
            {
                selector: '[data-tut="reactour__navegateTemplate"]',
                content: () => {
                    return (
                        <div >
                            <Row gutter={0} >
                                <Col span={24}><b> {t("Template's page")} </b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24}>
                                    {t("Select an option to create or visualize templates for tasks or projects.")}
                                </Col>
                            </Row>
                        </div>
                    )
                },
                position: 'left',
            },
            {
                selector: '[data-tut="reactour__navegateTemplate1"]',
                content: () => {
                    return (
                        <div >
                            <Row gutter={0} >
                                <Col span={24}><b> {t("Template's page")}</b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24}>
                                    {t("Explore task and project templates. Filter, create, edit, and delete templates.")}
                                </Col>
                            </Row>
                        </div>
                    )
                }
            },
        ],
        stepsTemplates2: [
            {
                selector: '[data-tut="reactour__templateInit"]',
                content: () => {
                    return (
                        <div>
                            <Row gutter={0} >
                                <Col span={24}><b> {t("Starting the journey through the Templates view")}</b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24} style={{}}> {t("To do this we propose you to follow the steps below...")}</Col>
                            </Row>
                        </div>
                    )
                }
            },
            {
                selector: '[data-tut="reactour__navegateTemplate2"]',
                content: () => {
                    return (
                        <div >
                            <Row gutter={0} >
                                <Col span={24}><b> {t("Template's page")} </b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24}>
                                    {t("Select an option to create or visualize templates for tasks or projects.")}
                                </Col>
                            </Row>
                        </div>
                    )
                },
                position: 'left',
            },
            {
                selector: '[data-tut="reactour__navegateTemplate1"]',
                content: () => {
                    return (
                        <div >
                            <Row gutter={0} >
                                <Col span={24}><b> {t("Template's page")}</b></Col>
                            </Row>
                            <Divider />
                            <Row gutter={0} >
                                <Col span={24}>
                                    {t("Explore task and project templates. Filter, create, edit, and delete templates.")}
                                </Col>
                            </Row>
                        </div>
                    )
                }
            },
        ],
    }
}


export default steps;
